export default () => ({
	init: false,
	loading: null,
	hideButton: null,
	loadNextBatch(batchSize = 1) {

		if (this.loading) return;

		let infiniteScrollNextPage = this.$refs.scrollNext
		let infiniteScrollContainer = this.$refs.scrollContainer

		if (!infiniteScrollNextPage || !infiniteScrollContainer) return;

		var infiniteScrollNextPageUrl = infiniteScrollNextPage.getAttribute('href')

		infiniteScrollNextPage.parentNode.removeChild(infiniteScrollNextPage)

		this.loading = true

		fetch(infiniteScrollNextPageUrl)
			.then(
				response => {
					return response.text()
				}
			)
			.then(
				html => {

					var content = new DOMParser().parseFromString(html, 'text/html')

					infiniteScrollContainer.innerHTML = infiniteScrollContainer.innerHTML + content.getElementById('js-scroll__items').innerHTML

					if (this.$refs.scrollNext == null) {
						this.hideButton = true
					}

					this.init = true;
					this.loading = null;

				}
			);

	}
})
